import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import "./css/default/main.css";
import "./css/animate.css";
import {Provider} from 'react-redux';
import Main from "./app/pages/Main/Main";
import reducer from './app/redux/reducers';
import {createStore, applyMiddleware} from "redux";
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {BrowserRouter as Router} from 'react-router-dom';
import $ from "jquery";
import logo from './assets/images/logo_test.png';
// let theme = localStorage.getItem('theme');
// theme = theme || 'default';
// theme === 'default' ? require('./css/default/main.css') : require('./css/dark/main.css');

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
store.subscribe(() => {

});

if ( !Object.entries ) {
	(function () {
		const hasOwn = Object.prototype.hasOwnProperty;
		Object.entries = function (obj) {
			const entrys = [];
			for ( const name in obj ) {
				if ( hasOwn.call(obj, name) ) {
					entrys.push([name, obj[name]]);
				}
			}
			return entrys;
		};
	})();
}

$(window).scroll(function () {
	const $scrollBtn = $('.scroll-top');
	const $topmenu = $('#topmenu');
	const $coupon = $('.body__container__side-left .fixed');

	const topOffset = 44;

	if ( $(this).scrollTop() >= topOffset ) {
		$topmenu.addClass('fixed');
		$coupon.parent().addClass('event-id');
		$topmenu.prev('.container').css({
			marginBottom : '40px'
		});

		$scrollBtn.fadeIn();
	} else {
		$topmenu.removeClass('fixed');
		$coupon.parent().removeClass('event-id');
		$topmenu.prev('.container').css({
			marginBottom : '0'
		});

		$scrollBtn.fadeOut();
	}
});

const IE = '\v' == 'v';

if ( IE ) {
	ReactDOM.render(
		<div id="old-browser">
			<div className="header__logo logo">
				<img src={logo} style={{height : 100}}/>
			</div>
			<div className="info">
				<p>Вы используете устаревшую версию браузера.</p>
				<p>
					Обновите Ваш браузер или установите нормальный и современный<br/>
					для лучшего отображения данного
					сайта.
				</p>
				<ul>
					<li><a href="https://www.google.com/chrome/browser/desktop/index.html">Google Chrome</a></li>
					<li><a href="https://www.mozilla.org/ru/firefox/new/">Mozilla Firefox</a></li>
					<li><a href="http://www.opera.com/ru/computer/windows">Opera</a></li>
				</ul>
			</div>
		</div>, document.getElementById('root'));
}
else {
	ReactDOM.render(
		<Provider store={store}>
			<Router>
				<Main/>
			</Router>
		</Provider>, document.getElementById('root'));
	registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js